import styled from "styled-components";

export const HeaderOneCont = styled.section`
  
  & hr {
    border-right: 1px solid #d1d1d6;
    height:15px
  }
  & .withPhone svg{margin-top:-5px}
`;
